import { DocumentViewListPage } from "./_DocumentViewListPage";
import { fetchDocumentsOrgTree } from "@/features/document/api";

export function DocumentOrgTreePage() {
  return (
    <DocumentViewListPage
      title="Văn bản đơn vị"
      breadcrumb="Quản lý Văn bản › Văn bản đơn vị"
      queryKey="documents-org-tree"
      fetcher={fetchDocumentsOrgTree}
    />
  );
}
